import api, { UPLOAD_TIMEOUT } from "../../utils/config/apiClient";
import {
  BASE_URL,
  LOGIN_API,
  ANNOUNCEMENT_GETANNOUNCEMENTDATA,
  GET_TOURNAMENT_TEAM_MATCH,
  TOURNAMENT_UPDATE_PLAYER_MATCH_DATE,
  ANNOUNCEMENT_GETWINNERDEATILS,
  ANNOUNCEMENT_GETWINNERS,
  ANNOUNCEMENT_GETWINNERSAUCTIONS,
  ANNOUNCEMENT_UPDATETEAMBUYBACK,
  ANNOUNCEMENT_GETUNREADNOTIFICATIONS,
  ANNOUNCEMENT_MARKNOTIFICATIONSSEEN,
  BROADCAST_GETRECIPIENTS,
  BROADCAST_SEND,
  BROADCAST_GETBROADCASTS,
  BROADCAST_GETBYID,
  GET_BID_AMOUNT_REPORT,
  ANNOUNCEMENT_GETALLAUCTION,
  MANAGER_GETBYID,
  BID_GETBIDWITHSTATUS,
  USER_GetAll,
  FORGET_API,
  LINK_VERIFY_API,
  UPDATE_PASSWORD_API,
  CHANGE_PASSWORD_API,
  ORGANIZATION_REGISTRATION_API,
  ORGANIZATION_GETALL_API,
  ORGANIZATION_Delete_API,
  ORGANIZATION_ViewID_API,
  ORGANIZATION_Update_API,
  ORGANIZATION_Country_API,
  ORGANIZATION_State_API,
  ORGANIZATION_City_API,
  ORGANIZATION_GetRecent,
  ORGANIZATION_TotalCount,
  USER_REGISTRATION_API,
  USER_TotalCount,
  SPORTS_REGISTRATION_API,
  UPLOAD_IMAGE,
  SPORTS_GETALL,
  SPORTS_DELETE,
  SPORTS_Total,
  SPORTS_UPDATE,
  WEB_ADMIN_PROFILE,
  USER_GETID,
  TEAM_GETALL_API,
  TEAM_REG_API,
  TEAM_DELETE_API,
  TEAM_UPDATE_API,
  EMAIL_EXISTS,
  TEAM_TOTAL_API,
  TOURNAMENT_REG,
  TOURNAMENT_GET,
  TOURNAMENT_DELETE,
  TOURNAMENT_GET_COUNT,
  TOURNAMENT_UPDATE,
  AUCTION_REG,
  AUCTION_GET_ALL,
  AUCTION_GET_COUNT,
  AUCTION_DELETE_API,
  AUCTION_UPDATE,
  BID_GET_COUNT,
  AUCTION_GETBYID,
  REG_BID,
  GETALL_BID,
  TOURNAMENT_GET_ID,
  // Batch 4.1 (#82/#83/#84/#85): bracket system disabled - see the wrappers further down.
  // TOURNAMENT_GET_ID_BRACKETS,
  // TOURNAMENT_BRACKETS_ID,
  AUCTION_RECENT,
  PAYMENT_ADD,
  NOTIFICATION_MESSAGE,
  NOTIFICATION_MESSAGE_REG,
  TEAMGETBYSPORT,
  AUCTIONWININGCOUNT,
  AUCTIONGETTEAM,
  GETBIDBYMANAGER,
  RECENT_BID,
  ADMIN_GET,
  ADMIN_REGISTER,
  TOURNAMENT_GET_RECENT,
  CHECKOUTPAYMENTSTATUS,
  // PAYMENTHISTORY, // disabled with /WebAdmin/AccountHistory (WEB-72)
  BID_STATUS,
  // Batch 4.1: bracket system disabled.
  // BRACKETSUFFLE,
  GETBYIDPAYMENT,
  AUCTION_AUCTIONDATABYFILTER,
  SECODARY_MARKETAUCTION,
  SECODARY_MARKETAUCTION_WINNER,
  // Batch 4.1: bracket system disabled.
  // TOURNAMENT_BRACKETS_UPDATE,
  // TOURNAMENT_BRACKETS_DATE,
  AUCTION_AUCTIONPLAYPAUSESTATUS,
  CONTACTUS,
  CONTACTUSDETAILS,
  INVOICEDETAILS,
  PLAYER_GET_REQUESTABLE_MANAGERS,
  PLAYER_GET_MANAGERS,
  PLAYER_GET_MANAGER_COUNTS,
  PLAYER_SUBSCRIBE_MANAGERS,
  PLAYER_CANCEL_MANAGER_REQUEST,
  PLAYER_DELETION_IMPACT,
  PLAYER_REQUEST_DELETION,
  PLAYER_GET_EMAIL_SETTINGS,
  PLAYER_UPDATE_EMAIL_SETTINGS,
  PLAYER_UPDATE_MANAGER_EMAILS,
  UNSUBSCRIBE_DETAILS,
  UNSUBSCRIBE_CONFIRM,
  ACCOUNT_GET_EMAIL_VERIFICATION,
  ACCOUNT_SEND_VERIFICATION_EMAIL,
  ACCOUNT_VERIFY_EMAIL,
  ACCOUNT_RESEND_VERIFICATION_EMAIL,
  ACCOUNT_CANCEL_DELETION,
  PLAYER_ADMIN_CANCEL_DELETION,
  SECODARY_MARKETAUCTION_SMBIDSELL,
  MANAGER_GETPLAYERREQUEST,
  MANAGER_PLAYERAPPROVAL,
  PLAYER_GETSUBSCRIBE_MANAGER,
  PLAYER_AUCTIONS,
  PLAYER_AUCTION_DETAILS,
  PLAYER_LOT_RECENT_BIDS,
  GETBIDWINNER,
  GETBIDCOUNTDATA,
  SMREG_BID,
  SECONDARYBIDH,
  BID_GETAUCTION_TEAMWINNER,
  SUBCRIPTIONREVENUE,
  SECODARY_MARKETAUCTION_ANNOUNCEMENT,
  REPORTDATAAPI,
  SUBSCRIPTION_CONT,
  SM_MY_BID_HISTORY,
  CREATEPAYMENTURL,
  COMMON_REDEEM_PROMOCODE,
  COMMON_GENERATE_PROMOCODE,
  TOURNAMENT_UPDATE_PLAYER_MATCH_SCORE,
  COMMON_GET_PROMOCODES,
  SPORTS_GETID,
  GETSUBSCRIPTIONDETAILS,
  CANCELAUTORENEW,
  AUCTIONPASS_OPTIONS,
  AUCTIONPASS_SESSION,
  AUCTIONPASS_REDEEM,
  SECODARY_MARKETAUCTION_SMGETAUCTIONBYID,
  AUCTION_SHOWPLACEBID,
} from "../../utils/config/config";
import { GetUser } from "../../utils/helper/helper";
import { imageFileError } from "../../utils/helper/imageUpload";

/**
 * EVERY CATCH IN THIS FILE RETURNS THE SAME SHAPE ITS OWN TRY RETURNS (WEB-P1-161).
 *
 *   try returns `response`       ->  catch returns `error?.response`
 *   try returns `response.data`  ->  catch returns `error?.response?.data`
 *
 * Before this, 138 wrappers ended in one of four shapes that had nothing to do with what the
 * success path returned - 93 `return error`, 31 with an empty body returning undefined, 14
 * `return err?.response?.data` against a try that returned the whole response, and 3
 * `return error?.data?.response`, a path that does not exist on an AxiosError. So a caller
 * reading `res.data.status` - which is what nearly every screen does - found `undefined` on
 * failure rather than `false`, and rendered an empty table with no message. That is the whole
 * of WEB-P1-161's "screens fail silently".
 *
 * WHY THIS WORKS WITHOUT TOUCHING THE CALLERS: the API answers every failure with the same
 * envelope it answers every success with. Business refusals are HTTP 200 carrying
 * `status: false`, and ErrorDetails - the body of a 500 - derives from ResponseModel for
 * exactly this reason, so `error.response.data` is already `{ status: false, message }` in
 * camelCase. Aligning the shape is all that was needed; `readApiBody` and `readApiMessage`
 * already read both.
 *
 * WHY THESE STILL RESOLVE INSTEAD OF THROWING. Making them reject is the tidier end state, but
 * 121 of 179 call sites have no try/catch, there is no `.catch()` anywhere in src/ on a service
 * call, and there is no ErrorBoundary or unhandledrejection handler - so every one of them would
 * become a silent unhandled rejection, which is a worse version of the bug being fixed here.
 *
 * `error?.response` IS DELIBERATELY UNDEFINED WHEN THERE WAS NO REPLY AT ALL. apiClient.js has
 * already toasted "Cannot reach the server" or "The server took too long" by then, and
 * checkout.js keys `notified: body === null` off exactly that undefined to know not to fire a
 * second toast. Synthesising a body here would double up on every offline click.
 */

export const loginUserAPI = async (userData) => {
  try {
    const response = await api.post(BASE_URL + LOGIN_API, userData);
    // #111: a wrong email or password is HTTP 200 with status false and no token, so these wrote
    // the string "undefined" - which reads back as a session. The header then offered Dashboard
    // to a signed-out visitor, and PrivateRoute, finding no role, sent them to Login. Both callers
    // (Login.js, LoginUser in auth-reducer.js) store the tokens themselves after checking status.
    // localStorage.setItem("isToken", response.data.token);
    // localStorage.setItem("isRefreshToken", response.data.refreshToken);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const TournamentRegApi = async (userData) => {
  try {
    const response = await api.post(
      BASE_URL + TOURNAMENT_REG,
      userData
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const SubscriptionDataFilterByDate = async (
  startAuctionDate,
  endAuctionDate
) => {
  try {
    const response = await api.get(
      `${
        BASE_URL + SUBCRIPTIONREVENUE
      }?startDate=${startAuctionDate}&endDate=${endAuctionDate}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const SecondaryMarketAnnouncement = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + SECODARY_MARKETAUCTION_ANNOUNCEMENT}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetTournamentTeamMatch = async (GetId) => {
  try {
    const response = await api.get(
      BASE_URL + GET_TOURNAMENT_TEAM_MATCH + GetId
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const AuctionRegApi = async (userData) => {
  try {
    const response = await api.post(BASE_URL + AUCTION_REG, userData);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const AddPayment = async (userData) => {
  try {
    const response = await api.post(BASE_URL + PAYMENT_ADD, userData);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const OrganizationReg = async (userData) => {
  try {
    const response = await api.post(
      BASE_URL + ORGANIZATION_REGISTRATION_API,
      [userData]
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const SportsReg = async (userData) => {
  try {
    const response = await api.post(
      BASE_URL + SPORTS_REGISTRATION_API,
      userData
    );
    return response;
  } catch (err) {
    return err?.response;
  }
};

export const UploadImage = async (userData) => {
  // #10: a file the server would refuse (type, over 2 MB) is refused here, in the shape of the
  // server's own refusal, so it never leaves the browser and every form shows the reason the way it
  // already shows a server refusal. The server still checks; this is not the authority.
  const refusal = imageFileError(userData?.get?.("file"));
  if (refusal) return { data: { status: false, message: refusal } };

  try {
    // Image upload moves real bytes over slow uplinks, so it overrides the default ceiling.
    let config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: UPLOAD_TIMEOUT,
    };
    const response = await api.post(
      BASE_URL + UPLOAD_IMAGE,
      userData,
      config
    );
    return response;
  } catch (err) {
    return err?.response;
  }
};

export const UserReg = async (userData) => {
  try {
    const response = await api.post(
      BASE_URL + USER_REGISTRATION_API,
      userData
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const NotificationReg = async (updatedata) => {
  try {
    const response = await api.post(
      BASE_URL + NOTIFICATION_MESSAGE_REG,
      updatedata
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const BidReg = async (userData) => {
  try {
    const response = await api.post(BASE_URL + REG_BID, userData);
    return response;
  } catch (error) {
    return error?.response;
  }
};
export const SmBidReg = async (userData) => {
  try {
    const response = await api.post(BASE_URL + SMREG_BID, userData);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const OragnizationAll = async (userData) => {
  try {
    const response = await api.get(
      BASE_URL + ORGANIZATION_GETALL_API
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const AuctionAll = async () => {
  try {
    const response = await api.get(BASE_URL + BID_GETBIDWITHSTATUS);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const AuctionGetAll = async () => {
  try {
    const response = await api.get(BASE_URL + AUCTION_GET_ALL);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const AuctionPlaceBid = async (data) => {
  try {
    const response = await api.get(`${BASE_URL + AUCTION_SHOWPLACEBID}?auctionId=${data}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};


export const GetNotificationMes = async () => {
  try {
    const response = await api.get(BASE_URL + NOTIFICATION_MESSAGE);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const AuctionRecent = async () => {
  try {
    const response = await api.get(BASE_URL + AUCTION_RECENT);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const AuctionCount = async () => {
  try {
    const response = await api.get(BASE_URL + AUCTION_GET_COUNT);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const TournamentAll = async (userData) => {
  try {
    const response = await api.get(BASE_URL + TOURNAMENT_GET);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const TournamentGetCount = async (userData) => {
  try {
    const response = await api.get(BASE_URL + TOURNAMENT_GET_COUNT);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const RecentBidGet = async (userData) => {
  try {
    const response = await api.get(BASE_URL + RECENT_BID);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const TeamReg = async (userData) => {
  try {
    const response = await api.post(
      BASE_URL + TEAM_REG_API,
      userData
    );
    return response;
  } catch (err) {
    return err?.response;
  }
};

export const ContactUsAPI = async (userData) => {
  try {
    const response = await api.post(BASE_URL + CONTACTUS, userData);
    return response;
  } catch (err) {
    return err?.response;
  }
};

export const CreatePymenentUrlFn = async (userData) => {
  try {
    const response = await api.post(
      `${BASE_URL + CREATEPAYMENTURL}=${userData}`,
      {}
    );
    return response;
  } catch (err) {
    return err?.response;
  }
};

// --- One-time access to a single auction ---------------------------------------------------
// The server owns every decision and every message here: what is on offer, whether the player
// may buy it, and what to say when they may not. These wrappers add nothing but the auction id.

export const GetAuctionPassOptions = async (auctionId) => {
  try {
    const response = await api.get(
      `${BASE_URL + AUCTIONPASS_OPTIONS}?auctionId=${auctionId}`
    );
    return response;
  } catch (err) {
    return err?.response;
  }
};

export const CreateAuctionPassSession = async (auctionId) => {
  try {
    const response = await api.post(
      `${BASE_URL + AUCTIONPASS_SESSION}?auctionId=${auctionId}`,
      {}
    );
    return response;
  } catch (err) {
    return err?.response;
  }
};

export const RedeemAuctionPassCredit = async (auctionId) => {
  try {
    const response = await api.post(
      `${BASE_URL + AUCTIONPASS_REDEEM}?auctionId=${auctionId}`,
      {}
    );
    return response;
  } catch (err) {
    return err?.response;
  }
};

let timeout = null;

export function debounce(func, delay) {
  return () => {
    if (timeout) clearTimeout(timeout);

    timeout = setTimeout(() => {
      return func();
    }, delay);
  };
}

// #104: there is no RefreshToken export any more. It began as a debounce() wrapper that returned
// undefined, then became a pass-through to refreshSession() - and a component-facing way to rotate
// the session is exactly what let TopNavbar and the SignalR provider race the client's own
// renewals. Renewal lives only in utils/config/apiClient.js; do not bring a wrapper back here.

export const TournamentUpdatePlayerMatchDate = async (item) => {
  try {
    const response = await api.post(
      BASE_URL + TOURNAMENT_UPDATE_PLAYER_MATCH_DATE,
      item
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const TournamentUpdatePlayerMatchScore = async (item) => {
  try {
    const response = await api.post(
      BASE_URL + TOURNAMENT_UPDATE_PLAYER_MATCH_SCORE,
      item
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};
export const SecondaryMarketMyBidHistory = async () => {
  try {
    const response = await api.get(BASE_URL + SM_MY_BID_HISTORY);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const AuctionDataFilterByDate = async (
  startAuctionDate,
  endAuctionDate
) => {
  try {
    const response = await api.get(
      `${
        BASE_URL + AUCTION_AUCTIONDATABYFILTER
      }?startDate=${startAuctionDate}&endDate=${endAuctionDate}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * Confirms a Stripe checkout session and reconciles the subscription it created.
 *
 * Pass the sessionId read back off the success URL so the correct checkout is confirmed; with
 * no argument the server falls back to the caller's most recent session.
 */
export const CheckoutAddPaymentStatus = async (sessionId) => {
  try {
    const url = sessionId
      ? `${BASE_URL + CHECKOUTPAYMENTSTATUS}?sessionId=${encodeURIComponent(sessionId)}`
      : BASE_URL + CHECKOUTPAYMENTSTATUS;
    const response = await api.get(url);
    return response;
  } catch (err) {
    return err?.response;
  }
};

/**
 * Turns auto-renewal off, or back on, for the logged-in user's subscription.
 *
 * Cancelling does not end access immediately: the user keeps bidding until the end of the
 * period they have already paid for.
 *
 * @param {boolean} cancelAtPeriodEnd true to stop renewing, false to resume.
 */
export const CancelAutoRenew = async (cancelAtPeriodEnd = true) => {
  try {
    const response = await api.post(
      `${BASE_URL + CANCELAUTORENEW}?cancelAtPeriodEnd=${cancelAtPeriodEnd}`,
      {}
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const SecondaryMarketAuction = async () => {
  try {
    const response = await api.get(BASE_URL + SECODARY_MARKETAUCTION);
    return response;
  } catch (err) {
    return err?.response;
  }
};

export const AuctionPlayPause = async (auctionId, pause) => {
  try {
    const response = await api.post(
      `${
        BASE_URL + AUCTION_AUCTIONPLAYPAUSESTATUS
      }?auctionId=${auctionId}&playPauseAuction=${pause}`,
      {}
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const PaymentGetById = async (data) => {
  try {
    // const response = await api.get(BASE_URL + GETBYIDPAYMENT);
    const response = await api.get(
      `${BASE_URL + GETBYIDPAYMENT}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`
    );

    return response;
  } catch (err) {
    return err?.response;
  }
};
export const GetBidCountDetail = async (id) => {
  try {
    const response = await api.get(BASE_URL + GETBIDCOUNTDATA);

    return response;
  } catch (err) {
    return err?.response;
  }
};

export const SportAllMap = async (data) => {
  try {
    const response = await api.get(BASE_URL + SPORTS_GETALL);
    return response;
  } catch (error) {
    return error?.response;
  }
};
/**
 * POST, not GET: redeeming changes state. As a GET it needed an entry in apiClient's
 * NON_IDEMPOTENT_GETS to stop the retry wrapper claiming a code twice.
 */
export const RedeemPromoCode = async (promoCode) => {
  try {
    const response = await api.post(
      `${BASE_URL + COMMON_REDEEM_PROMOCODE}?promoCode=${encodeURIComponent(
        promoCode
      )}`,
      {}
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * @param {string} endDate ISO-8601 UTC, i.e. Date.prototype.toISOString(). The API binds this to
 *   a DateTime the procedure compares against GETUTCDATE(), and the promo grid renders it back as
 *   UTC - so sending local wall-clock shows the admin an expiry they did not pick.
 * @param {number|null} maxRedemptions How many accounts may redeem it; null means unlimited.
 * @param {number} grantDurationDays Days of access a redemption grants, from when it is redeemed.
 */
export const GeneratePromoCode = async (
  endDate,
  maxRedemptions,
  grantDurationDays
) => {
  try {
    // Unlimited is its own boolean, and an empty maxRedemptions would NOT do instead: an API
    // parameter that has a default value never binds to null, so "maxRedemptions=" quietly
    // produced a single-use code. Omitting the count keeps that safe default if the flag is ever
    // lost in transit.
    const isUnlimited = maxRedemptions === null || maxRedemptions === undefined;
    const params = new URLSearchParams({ endDate });
    if (!isUnlimited) {
      params.append("maxRedemptions", String(maxRedemptions));
    }
    params.append("unlimitedRedemptions", isUnlimited ? "true" : "false");
    params.append("grantDurationDays", String(grantDurationDays));
    const response = await api.post(
      `${BASE_URL + COMMON_GENERATE_PROMOCODE}?${params.toString()}`,
      {}
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

// Disabled with /WebAdmin/AccountHistory (WEB-72) - see PAYMENTHISTORY in config.js.
// export const PaymentHistory = async () => {
//   try {
//     const response = await api.get(BASE_URL + PAYMENTHISTORY);
//     return response;
//   } catch (error) {
//     return error;
//   }
// };
export const BidStatus = async (data) => {
  try {
    const response = await api.get(`${BASE_URL + BID_STATUS}`);

    return response;
  } catch (error) {
    return error?.response;
  }
};

export const AuctionGetTeam = async (id) => {
  try {
    const response = await api.get(
      `${BASE_URL + AUCTIONGETTEAM}?auctionId=${id}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const SportAll = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + SPORTS_GETALL}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`
    );

    return response;
  } catch (error) {
    return error?.response;
  }
};

export const SportAllSearch = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + SPORTS_GETALL}?SearchTerm=${data?.SearchTerm}&SortColumn=${
        data?.SortColumn
      }&SortOrder=${data?.SortOrder}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * One page of the Manager's Auctions list (FE-16, #4). The search and the status are the server's,
 * so they cover every page and not only the loaded one: SearchTerm and Status are sent only when
 * there is one. A separate search request used to go without the page and the page size.
 *
 * @param {{SortOrder: boolean, PageNumber: number, PageSize: number, SearchTerm?: string, Status?: string}} data
 */
export const AuctionGetAllData = async (data) => {
  try {
    const params = searchedPageQuery(data);
    if (data?.Status) params.set("Status", data.Status);
    const response = await api.get(`${BASE_URL + AUCTION_GET_ALL}?${params}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const EmailCheck = async (userData) => {
  try {
    // Encoded, or a query string reads "+" as a space: "test+1@gmail.com" was looked up as
    // "test 1@gmail.com", so sign-up never warned that a plus address was already registered.
    const response = await api.get(
      `${BASE_URL + EMAIL_EXISTS}?emailId=${encodeURIComponent(userData.email)}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const UserAll = async (userData) => {
  try {
    const response = await api.get(BASE_URL + USER_GetAll);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const SecodaryBidHistory = async (userData) => {
  try {
    const response = await api.get(BASE_URL + SECONDARYBIDH);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const BidAll = async () => {
  try {
    const response = await api.get(BASE_URL + GETALL_BID);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const TeamGetAll = async (data) => {
  try {
    const response = await api.get(BASE_URL + TEAM_GETALL_API);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const TeamAll = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + TEAM_GETALL_API}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const TeamAllSearch = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + TEAM_GETALL_API}?SearchTerm=${
        data?.SearchTerm
      }&SortColumn=${data?.SortColumn}&SortOrder=${data?.SortOrder}`
    );

    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * The query string of a paged list whose search is the server's (#184 reopened, as #147): SortOrder,
 * PageNumber and PageSize, and SearchTerm only when there is one.
 *
 * @param {{SortOrder: boolean, PageNumber: number, PageSize: number, SearchTerm?: string}} data
 * @returns {URLSearchParams}
 */
const searchedPageQuery = (data) => {
  const params = new URLSearchParams({
    SortOrder: String(data?.SortOrder),
    PageNumber: String(data?.PageNumber),
    PageSize: String(data?.PageSize),
  });
  if (data?.SearchTerm) params.set("SearchTerm", data.SearchTerm);
  return params;
};

export const BidWinnerListData = async (data) => {
  try {
    // #184 (reopened): the search goes to the server, so it covers every page and not only the
    // loaded one.
    const response = await api.get(`${BASE_URL + GETBIDWINNER}?${searchedPageQuery(data)}`);

    return response;
  } catch (error) {
    return error?.response;
  }
};
export const GetAnnouncementGetAllAuctionData = async (data) => {
  try {
    // #147: the search goes to the server, so it covers every page and not only the loaded one.
    const params = new URLSearchParams({
      SortOrder: String(data?.SortOrder),
      PageNumber: String(data?.PageNumber),
      PageSize: String(data?.PageSize),
    });
    if (data?.SearchTerm) params.set("SearchTerm", data.SearchTerm);
    const response = await api.get(`${BASE_URL + ANNOUNCEMENT_GETALLAUCTION}?${params}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetNotificationMesData = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + NOTIFICATION_MESSAGE}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const ManagerGetPlayerRequestData = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + MANAGER_GETPLAYERREQUEST}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};
export const AuctionGetAllDataWeb = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + AUCTION_GET_ALL}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const AdminGetData = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + ADMIN_GET}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};
export const SecondaryMarketAuctionSell = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + SECODARY_MARKETAUCTION}?SearchTerm=${data.SearchTerm}&SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`
    );
    return response;
  } catch (err) {
    return err?.response;
  }
};

// export const GetWinnerAuctionData = async (data) => {
//   try {
//     let token = GetToken();
//     let config = {
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${token}`,
//       },
//     };

//     const response = await api.get(
//       `${BASE_URL + SECODARY_MARKETAUCTION_WINNER}?SortOrder=${
//         data?.SortOrder
//       }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
//       config
//     );
//     return response;
//   } catch (error) {
//     return error;
//   }
// };

export const GetWinnerAuctionData = async (data) => {
  try {
    // const response = await api.get(
    //   `${BASE_URL + SECODARY_MARKETAUCTION_WINNER}?SortOrder=${
    //     data?.SortOrder
    //   }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`,
    //   config
    // );
     const response = await api.get(
      `${BASE_URL + SECODARY_MARKETAUCTION_WINNER}?SearchTerm=${data?.SearchTerm}&SortColumn=${
        data?.SortColumn
      }&SortOrder=${data?.SortOrder}&PageNumber=${data?.PageNumber}&PageSize=${
        data?.PageSize
      }`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetContactUsDetailsData = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + CONTACTUSDETAILS}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetPromoCodesData = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + COMMON_GET_PROMOCODES}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`
    );

    return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetInvoiceDetailsData = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + INVOICEDETAILS}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};
export const OragnizationAllData = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + ORGANIZATION_GETALL_API}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const UserAllData = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + USER_GetAll}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}&SearchTerm=${data?.SearchTerm}&SortColumn=${data?.SortColumn}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const SecodaryBidHistoryData = async (data) => {
  try {
    // #184 (reopened): the search goes to the server (searchedPageQuery).
    const response = await api.get(`${BASE_URL + SECONDARYBIDH}?${searchedPageQuery(data)}`);

    return response;
  } catch (error) {
    return error?.response;
  }
};

export const SecondaryMarketMyBidHistoryData = async (data) => {
  try {
    // #184 (reopened): the search goes to the server (searchedPageQuery).
    const response = await api.get(`${BASE_URL + SM_MY_BID_HISTORY}?${searchedPageQuery(data)}`);

    return response;
  } catch (error) {
    return error?.response;
  }
};
export const SecondaryMarketAuctionData = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + SECODARY_MARKETAUCTION}?PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`
    );
    return response;
  } catch (err) {
    return err?.response;
  }
};
export const GetNotificationMesDataPlayer = async (data) => {
  try {
    // #238: Platform=Web also lists the bid notifications (Outbid, Won, Lost), which the server
    // keeps from the mobile app.
    const response = await api.get(
      `${BASE_URL + NOTIFICATION_MESSAGE}?SortOrder=${
        data?.SortOrder
      }&PageNumber=${data?.PageNumber}&PageSize=${data?.PageSize}&Platform=Web`
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

/**
 * #196: the Player bell's number and newest unread message, as `data: { unreadCount, latestMessage }`.
 * Unread means created after the player last opened the Notifications page.
 */
export const GetUnreadNotifications = async () => {
  try {
    // #227: Platform=Web is what gets a Player's "Buy Subscription" / "Complete Payment" system
    // notifications. The server sends any other caller, one that names no platform included, the
    // profile one only, because the mobile app must never mention buying a subscription.
    const response = await api.get(
      `${BASE_URL + ANNOUNCEMENT_GETUNREADNOTIFICATIONS}?Platform=Web`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

/** #196: everything up to now counts as read. Called when the Player's Notifications page opens. */
export const MarkNotificationsSeen = async () => {
  try {
    const response = await api.post(BASE_URL + ANNOUNCEMENT_MARKNOTIFICATIONSSEEN, {});
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const BidStatusData = async (data) => {
  try {
    // #133: ManagerId is the Auctions page "Select Manager" filter; left out for "All managers".
    const managerFilter = data?.ManagerId ? `&ManagerId=${data.ManagerId}` : "";
    // #196: encoded, because the search now also carries an auction name from a start reminder,
    // and a name with "&", "#" or "+" in it used to cut the query short.
    const response = await api.get(
      `${BASE_URL + BID_STATUS}?SearchTerm=${encodeURIComponent(data?.SearchTerm ?? "")}&SortColumn=${
        data?.SortColumn
      }&SortOrder=${data?.SortOrder}&PageNumber=${data?.PageNumber}&PageSize=${
        data?.PageSize
      }${managerFilter}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * One page of the Player's Auctions list (#236), one row per auction. Tab is "Live" (Live and
 * Upcoming) or "Closed"; ManagerIds is a comma-separated list, left out for "All managers".
 */
export const GetPlayerAuctions = async (data) => {
  try {
    const response = await api.get(BASE_URL + PLAYER_AUCTIONS, {
      params: {
        SearchTerm: data?.SearchTerm || undefined,
        SortOrder: data?.SortOrder,
        PageNumber: data?.PageNumber,
        PageSize: data?.PageSize,
        Tab: data?.Tab,
        ManagerIds: data?.ManagerIds || undefined,
      },
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};

// #237: one auction with every lot, for the Auction Details page. A GET that changes nothing.
export const GetPlayerAuctionDetails = async (auctionId) => {
  try {
    const response = await api.get(BASE_URL + PLAYER_AUCTION_DETAILS, { params: { auctionId } });
    return response;
  } catch (error) {
    return error?.response;
  }
};

// #239: the five newest bids of one lot, for Recent Bids on the Auction Details page.
export const GetPlayerLotRecentBids = async (auctionId, teamId) => {
  try {
    const response = await api.get(BASE_URL + PLAYER_LOT_RECENT_BIDS, { params: { auctionId, teamId } });
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const BidAllData = async (data) => {
  try {
    // #184 (reopened): the search goes to the server (searchedPageQuery).
    const response = await api.get(`${BASE_URL + GETALL_BID}?${searchedPageQuery(data)}`);

    return response;
  } catch (error) {
    return error?.response;
  }
};
export const TournamentAllData = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + TOURNAMENT_GET}?SortOrder=${data?.SortOrder}&PageNumber=${
        data?.PageNumber
      }&PageSize=${data?.PageSize}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const TournamentAllDataSearch = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + TOURNAMENT_GET}?SearchTerm=${data?.SearchTerm}&SortColumn=${
        data?.SortColumn
      }&SortOrder=${data?.SortOrder}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const MangergetBid = async (data) => {
  try {
    const response = await api.get(
      `${BASE_URL + GETBIDBYMANAGER}?id=${data}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const ManagerGetById = async (id) => {
  try {
    const response = await api.get(`${BASE_URL + MANAGER_GETBYID}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const PlayerGetById = async (id) => {
  try {
    const response = await api.get(`${BASE_URL + USER_GETID}${id}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const SportGetById = async (id) => {
  try {
    const response = await api.get(`${BASE_URL + SPORTS_GETID}${id}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const WinCount = async (id) => {
  try {
    const response = await api.get(
      `${BASE_URL + AUCTIONWININGCOUNT}?NoOfTeams=${id}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const TeamTotal = async (userData) => {
  try {
    const response = await api.get(BASE_URL + TEAM_TOTAL_API);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetWinnerAuction = async (userData) => {
  try {
    const response = await api.get(
      BASE_URL + SECODARY_MARKETAUCTION_WINNER
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetReportData = async (startAuctionDate, endAuctionDate) => {
  try {
    const response = await api.get(
      `${
        BASE_URL + REPORTDATAAPI
      }?startDate=${startAuctionDate}&endDate=${endAuctionDate}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetBidAmountReport = async () => {
  try {
    const response = await api.get(BASE_URL + GET_BID_AMOUNT_REPORT);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetSubscriptionCount = async (
  startAuctionDate,
  endAuctionDate
) => {
  try {
    const response = await api.get(
      `${
        BASE_URL + SUBSCRIPTION_CONT
      }?startDate=${startAuctionDate}&endDate=${endAuctionDate}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const SecondaryMarketBidSell = async (userData) => {
  try {
    const response = await api.post(
      BASE_URL + SECODARY_MARKETAUCTION_SMBIDSELL,
      userData
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};
export const ManagerGetPlayerRequest = async (userId) => {
  try {
    const response = await api.get(
      `${BASE_URL + MANAGER_GETPLAYERREQUEST}`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};
export const managerApproval = async (playerId, approval) => {
  try {
    const response = await api.put(
      `${
        BASE_URL + MANAGER_PLAYERAPPROVAL
      }?playerId=${playerId}&approved=${approval}`,
      {}
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const PlayerGetSubscribeManager = async (playerId) => {
  try {
    const response = await api.get(
      `${BASE_URL + PLAYER_GETSUBSCRIBE_MANAGER}`
    );
    return response;
  } catch (err) {
    return err?.response;
  }
};

// The managers a player can send a request to. Not Manager/GetAll: that is scoped to the
// caller's own manager record, which for a player matches nobody (#114).
export const PlayerGetRequestableManagers = async () => {
  try {
    const response = await api.get(BASE_URL + PLAYER_GET_REQUESTABLE_MANAGERS);
    return response;
  } catch (error) {
    return error?.response;
  }
};

// #133: one page of the Managers page / Discover Managers widget. Status is "All" (or omitted),
// "Subscribed", "Pending" or "Available"; each row carries the player's own status.
export const PlayerGetManagers = async ({ SearchTerm, Status, PageNumber, PageSize } = {}) => {
  try {
    const params = new URLSearchParams({
      PageNumber: String(PageNumber || 1),
      PageSize: String(PageSize || 6),
    });
    if (SearchTerm) params.set("SearchTerm", SearchTerm);
    if (Status) params.set("Status", Status);
    const response = await api.get(`${BASE_URL + PLAYER_GET_MANAGERS}?${params}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

// #133: the Managers page tab counters, which follow the search.
export const PlayerGetManagerCounts = async (SearchTerm) => {
  try {
    const params = new URLSearchParams();
    if (SearchTerm) params.set("SearchTerm", SearchTerm);
    const response = await api.get(`${BASE_URL + PLAYER_GET_MANAGER_COUNTS}?${params}`);
    return response;
  } catch (error) {
    return error?.response;
  }
};

// #133: the only way a player requests managers - one or several. The reply carries
// sentCount and skippedCount; managers no longer Available are skipped, not refused.
export const PlayerSubscribeManagers = async (managerIds) => {
  try {
    const response = await api.post(BASE_URL + PLAYER_SUBSCRIBE_MANAGERS, managerIds);
    return response;
  } catch (error) {
    return error?.response;
  }
};

// #133: cancels the player's Pending request to one manager.
export const PlayerCancelManagerRequest = async (managerId) => {
  try {
    const response = await api.post(
      `${BASE_URL + PLAYER_CANCEL_MANAGER_REQUEST}?managerId=${managerId}`,
      {}
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * #199: what deleting the signed-in Player's account affects - the deletion date, the
 * subscription, and the auctions, contests and secondary-market activity the warnings list.
 */
export const GetDeletionImpact = async () => {
  try {
    const response = await api.get(BASE_URL + PLAYER_DELETION_IMPACT);
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * #199: requests deletion of the signed-in Player's account. On success the server has already
 * ended the session, so the caller signs out at once (forceLogout, no revoke).
 */
export const RequestAccountDeletion = async () => {
  try {
    const response = await api.post(BASE_URL + PLAYER_REQUEST_DELETION, {});
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * #234: cancels the deletion request of the account signing in, and signs it in. Anonymous, like
 * loginUserAPI, with the same body ({ email, password }) and the same answer: on success the tokens
 * of a normal sign-in, which the caller stores itself after checking status. A refusal is HTTP 200
 * with status false and an errorCode (INVALID_CREDENTIALS, DELETION_IN_PROGRESS, ACCOUNT_BLOCKED).
 * `undefined` when there was no reply.
 */
export const cancelAccountDeletionAPI = async (credentials) => {
  try {
    const response = await api.post(BASE_URL + ACCOUNT_CANCEL_DELETION, credentials);
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * #234: the Web Admin cancels a Player's deletion request from the Players list. Nobody is signed
 * in by it; the player gets the cancellation email.
 */
export const AdminCancelAccountDeletion = async (playerId) => {
  try {
    const response = await api.post(
      `${BASE_URL + PLAYER_ADMIN_CANCEL_DELETION}?playerId=${playerId}`,
      {}
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

/** The signed-in Player's "Emails from Managers" switch: `broadcastEmails`. */
export const PlayerGetEmailSettings = async () => {
  try {
    const response = await api.get(BASE_URL + PLAYER_GET_EMAIL_SETTINGS);
    return response;
  } catch (error) {
    return error?.response;
  }
};

/** Turns the signed-in Player's "Emails from Managers" switch on or off. */
export const PlayerUpdateEmailSettings = async (broadcastEmails) => {
  try {
    const response = await api.post(
      `${BASE_URL + PLAYER_UPDATE_EMAIL_SETTINGS}?broadcastEmails=${Boolean(broadcastEmails)}`,
      {}
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

/** Turns one Manager's broadcast emails on or off for the signed-in Player (My Managers). */
export const PlayerUpdateManagerEmails = async (managerId, emails) => {
  try {
    const response = await api.post(
      `${BASE_URL + PLAYER_UPDATE_MANAGER_EMAILS}?managerId=${managerId}&emails=${Boolean(emails)}`,
      {}
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * What the unsubscribe page shows for a broadcast email's link: managerName, managerEmails (null
 * when the player is no longer that Manager's) and allEmails. The link's token alone names the
 * player, so the call carries no session (skipAuth): a different account signed in on this browser
 * must not matter, and a stale one must not start a refresh.
 */
export const UnsubscribeGetDetails = async (token) => {
  try {
    const response = await api.get(BASE_URL + UNSUBSCRIBE_DETAILS, { params: { token }, skipAuth: true });
    return response;
  } catch (error) {
    return error?.response;
  }
};

/** Turns emails off from a broadcast email's link: the link's Manager, or every Manager with `all`. */
export const UnsubscribeConfirm = async (token, all) => {
  try {
    const response = await api.post(BASE_URL + UNSUBSCRIBE_CONFIRM, {}, {
      params: { token, all: Boolean(all) },
      skipAuth: true,
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};

/** Whether the signed-in account's email is verified: emailVerified, emailId. */
export const GetEmailVerification = async () => {
  try {
    const response = await api.get(BASE_URL + ACCOUNT_GET_EMAIL_VERIFICATION);
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * Emails the signed-in account a new verification link (the banner's button). A refusal because the
 * email is already verified comes back with emailVerified true.
 */
export const SendVerificationEmail = async () => {
  try {
    const response = await api.post(BASE_URL + ACCOUNT_SEND_VERIFICATION_EMAIL, {});
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * Confirms an emailed verification link. The token names the account, so the call carries no
 * session (skipAuth), as on the unsubscribe page.
 */
export const VerifyEmail = async (token) => {
  try {
    const response = await api.post(BASE_URL + ACCOUNT_VERIFY_EMAIL, { token }, { skipAuth: true });
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * Emails a new verification link to a sign-up that cannot sign in yet. The account is named by the
 * email and password typed for the refused sign-in, so only its owner can have a link sent.
 */
export const ResendVerificationEmail = async (email, password) => {
  try {
    const response = await api.post(BASE_URL + ACCOUNT_RESEND_VERIFICATION_EMAIL, { email, password }, { skipAuth: true });
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const BidWinnerList = async () => {
  try {
    const response = await api.get(BASE_URL + GETBIDWINNER);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetInvoiceDetails = async () => {
  try {
    const response = await api.get(BASE_URL + INVOICEDETAILS);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetSubScription = async () => {
  try {
    const response = await api.get(BASE_URL + GETSUBSCRIPTIONDETAILS);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const GetContactUsDetails = async (userData) => {
  try {
    const response = await api.get(BASE_URL + CONTACTUSDETAILS);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const OragnizationGetRecent = async (userData) => {
  try {
    const response = await api.get(BASE_URL + ORGANIZATION_GetRecent);
    return response;
  } catch (error) {
    return error?.response;
  }
};
export const OragnizationGetTotal = async () => {
  try {
    const response = await api.get(
      BASE_URL + ORGANIZATION_TotalCount
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};
export const UserGetTotal = async () => {
  try {
    const response = await api.get(BASE_URL + USER_TotalCount);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const OragnizationCounrty = async () => {
  try {
    const response = await api.get(
      BASE_URL + ORGANIZATION_Country_API
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const OragnizationStates = async (countryId) => {
  try {
    const response = await api.get(
      BASE_URL + ORGANIZATION_State_API + countryId
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const OragnizationCity = async (stateId) => {
  try {
    const response = await api.get(
      BASE_URL + ORGANIZATION_City_API + stateId
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const SportTotalGet = async () => {
  try {
    const response = await api.get(BASE_URL + SPORTS_Total);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const OragnizationDelete = async (id, token) => {
  try {
    const response = await api.delete(
      BASE_URL + ORGANIZATION_Delete_API + id
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const TeamDelete = async (id) => {
  try {
    const response = await api.delete(
      BASE_URL + TEAM_DELETE_API + id
    );
    return response.data;
  } catch (error) {
    // Return the body rather than swallowing it. usp_DeleteTeamById refuses with HTTP 200, so
    // anything caught here is a 400/401/500 - and returning undefined made the caller render an
    // empty toast, which is how a refusal with a perfectly good message became a blank box.
    // Same shape as the success path, so the caller reads one thing either way.
    return error?.response?.data;
  }
};

export const AuctionDelete = async (id) => {
  try {
    const response = await api.delete(
      BASE_URL + AUCTION_DELETE_API + id
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const TournamentDelete = async (id) => {
  try {
    const response = await api.delete(
      BASE_URL + TOURNAMENT_DELETE + id
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const AuctionBYIdGet = async (id) => {
  try {
    const response = await api.get(
      BASE_URL + AUCTION_GETBYID + "/" + id
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const SecondryMarketSMgetAuctionById = async (data) => {
  let info = `?auctionId=${data.auctionId}&teamId=${data.teamId}&auctionLevel=${data.auctionLevel}`;
  try {
    const response = await api.get(
      BASE_URL + SECODARY_MARKETAUCTION_SMGETAUCTIONBYID + info
    );
    // The whole response, not its body: a closed listing is a 204, and only the status tells it
    // apart from a permission 401, whose body is just as empty (readListingReply).
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const AnnouncementData = async (auctionId) => {
  try {
    let config = {
      params: {
        auctionId: auctionId,
      },
    };
    const response = await api.get(
      BASE_URL + ANNOUNCEMENT_GETANNOUNCEMENTDATA,
      config
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const AnnouncemnetWinnerDetails = async (auctionId) => {
  try {
    let config = {
      params: {
        auctionId: auctionId,
      },
    };
    const response = await api.get(
      BASE_URL + ANNOUNCEMENT_GETWINNERDEATILS,
      config
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * One page of the Winners list (MG-012 / AD-012) for the signed-in Manager or Admin.
 *
 * Search, the auction filter and the Winning Amount sort all run on the server, so a search covers
 * every page. Leave AuctionId undefined for "All auctions": axios drops undefined params.
 *
 * @param {{ AuctionId?: number, SearchTerm?: string, SortOrder: boolean, PageNumber: number, PageSize: number }} params
 *   SortOrder true lists the highest Winning Amount first.
 */
export const GetWinnersData = async (params) => {
  try {
    const response = await api.get(BASE_URL + ANNOUNCEMENT_GETWINNERS, {
      params,
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * Saves the changed Team Buyback marks of one auction (MG-003.1) in one atomic request.
 *
 * The server answers a refused batch with 200 and status false, and a caller outside the auction's
 * manager team (who is not the Web Admin) with 403; both carry a readable message.
 *
 * @param {number} auctionId
 * @param {{ teamId: number, isBuyback: boolean }[]} teams Only the teams whose mark changed.
 */
export const UpdateTeamBuyback = async (auctionId, teams) => {
  try {
    const response = await api.put(BASE_URL + ANNOUNCEMENT_UPDATETEAMBUYBACK, {
      auctionId,
      teams,
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};

/** The completed auctions of the signed-in Manager's or Admin's manager team, for the Winners filter. */
export const GetWinnersAuctions = async () => {
  try {
    const response = await api.get(BASE_URL + ANNOUNCEMENT_GETWINNERSAUCTIONS);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const UserGetId = async (id) => {
  try {
    const user = JSON.parse(GetUser());
    const response = await api.get(
      BASE_URL + ORGANIZATION_ViewID_API + user?.userId
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const AdminReg = async (userData) => {
  try {
    const response = await api.post(
      BASE_URL + ADMIN_REGISTER,
      userData
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};
export const AdminGet = async (userData) => {
  try {
    const response = await api.get(BASE_URL + ADMIN_GET);
    return response;
  } catch (error) {
    return error?.response;
  }
};

export const SportDelete = async (id) => {
  try {
    const response = await api.delete(BASE_URL + SPORTS_DELETE + id);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const OragnizationViewId = async (id) => {
  try {
    const response = await api.get(
      BASE_URL + ORGANIZATION_ViewID_API + id
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const TournamentGetById = async (id) => {
  try {
    const response = await api.get(BASE_URL + TOURNAMENT_GET_ID + id);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const TournamentGetByIdGet = async (id) => {
  try {
    const response = await api.get(
      BASE_URL + `${TOURNAMENT_GET_ID}${id}`
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

// Batch 4.1 (#82/#83/#84/#85): bracket system disabled. This one was already dead before the
// change - "Tournament/Bracket/" has never existed on the API and nothing called it.
// export const TournamentGetByIdBarcket = async (id) => {
//   try {
//     const response = await api.get(
//       BASE_URL + TOURNAMENT_GET_ID_BRACKETS + id
//     );
//     return response.data;
//   } catch (error) {}
// };

export const TeamGetBy = async (id) => {
  try {
    const response = await api.get(BASE_URL + TEAMGETBYSPORT + id);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

// Batch 4.1 (#82/#84): bracket system disabled.
// export const TournamentBarcketId = async (GetId) => {
//   try {
//     const response = await api.get(
//       BASE_URL + TOURNAMENT_BRACKETS_ID + GetId
//     );
//     return response.data;
//   } catch (error) {}
// };

export const OragnizationUpdate = async (item) => {
  try {
    const response = await api.put(
      BASE_URL + ORGANIZATION_Update_API,
      [
        {
          ...item,
          crudOperationId: false,
        },
      ]
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

// Batch 4.1 (#83/#85): bracket scoring and bracket match scheduling disabled.
// export const TournamentUpdateTeamScore = async (item) => {
//   try {
//     const response = await api.post(
//       BASE_URL + TOURNAMENT_BRACKETS_UPDATE,
//       item
//     );
//     return response.data;
//   } catch (error) {}
// };

// export const TournamentUpdateTeamDate = async (item) => {
//   try {
//     const response = await api.post(
//       BASE_URL + TOURNAMENT_BRACKETS_DATE,
//       item
//     );
//     return response.data;
//   } catch (error) {}
// };

export const WebAdminProfile = async (item, token) => {
  try {
    const response = await api.put(
      BASE_URL + WEB_ADMIN_PROFILE,
      item
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

// Batch 4.1 (#82/#84): bracket team shuffling disabled.
// export const BracketUpdate = async (item) => {
//   try {
//     const response = await api.post(BASE_URL + BRACKETSUFFLE, item);
//     return response.data;
//   } catch (error) {}
// };

export const AuctionUpdate = async (item) => {
  try {
    const response = await api.put(BASE_URL + AUCTION_UPDATE, [item]);
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const TournamentUpdate = async (item) => {
  try {
    const response = await api.put(
      BASE_URL + TOURNAMENT_UPDATE,
      [item]
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const TeamUpdate = async (item) => {
  try {
    const response = await api.put(
      BASE_URL + TEAM_UPDATE_API,
      [{ ...item }]
    );
    return response.data;
  } catch (error) {
    // See TeamDelete. Team.SportId is now int? with [Range], so an omitted or zero sportId comes
    // back as a 400 carrying ValidationProblemDetails - which has no `message` member. Swallowing
    // it here left the user with no idea why the save did nothing; readApiMessage reads `errors`.
    return error?.response?.data;
  }
};

export const SportsUpdate = async (item) => {
  try {
    const response = await api.put(
      BASE_URL + SPORTS_UPDATE,
      [{ ...item }]
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const ForgetPasswordEmailSend = async (userPass) => {
  try {
    const email = userPass.email;
    const response = await api.post(
      `${BASE_URL + FORGET_API}?email=${encodeURIComponent(email)}`
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const linkVerify = async (value) => {
  try {
    const response = await api.post(
      `${BASE_URL + LINK_VERIFY_API}?token=${value}`
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const UpdatePasswordFn = async (updatedata) => {
  try {
    const response = await api.post(
      BASE_URL + UPDATE_PASSWORD_API,
      updatedata
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const ChangePasswordApi = async (updatedata) => {
  try {
    const response = await api.post(
      BASE_URL + CHANGE_PASSWORD_API,
      updatedata
    );
    return response.data;
  } catch (error) {
    return error?.response?.data;
  }
};

export const getBIdCount = async () => {
  try {
    const response = await api.get(BASE_URL + BID_GET_COUNT);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};
export const BidAuctionTeamWinner = async (auctionId, teamId, market) => {
  try {
    const response = await api.get(
      `${
        BASE_URL + BID_GETAUCTION_TEAMWINNER
      }?AuctionId=${auctionId}&TeamId=${teamId}&Market=Primary`
    );
    return response;
  } catch (error) {
    return error?.response;
  }
};
export const getRecentTournament = async () => {
  try {
    const response = await api.get(BASE_URL + TOURNAMENT_GET_RECENT);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

/**
 * MG-014 / AD-013 (#167, #168): the players the signed-in Manager or Admin may send a broadcast to,
 * with the sender name the players will see. Returns the full response.
 */
export const GetBroadcastRecipients = async () => {
  try {
    const response = await api.get(BASE_URL + BROADCAST_GETRECIPIENTS);
    return response;
  } catch (error) {
    return error?.response;
  }
};

/**
 * Sends a broadcast: `{ playerIds, subject, message }`. The server only saves it and returns at
 * once; the emails go out in the background. Returns the full response, or undefined with no reply.
 */
export const SendBroadcast = async (data) => {
  try {
    const response = await api.post(BASE_URL + BROADCAST_SEND, data);
    return response;
  } catch (error) {
    return error?.response;
  }
};

/** One page of the Broadcasting Center's history, for usePagedList. Returns the full response. */
export const GetBroadcasts = async ({ PageNumber, PageSize }) => {
  try {
    const response = await api.get(BASE_URL + BROADCAST_GETBROADCASTS, {
      params: { PageNumber, PageSize },
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};

/** One broadcast with every recipient's status (Broadcast Details). Returns the full response. */
export const GetBroadcastById = async (id) => {
  try {
    const response = await api.get(BASE_URL + BROADCAST_GETBYID, {
      params: { id },
    });
    return response;
  } catch (error) {
    return error?.response;
  }
};

const authService = {
  loginUserAPI,
};

export default authService;
